<template>
  <div class="custom-recipe">
    <AppNavbar :options="options" :zIndex="999"> </AppNavbar>
    <div>
      <img
        class="bg"
        src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/08e3457794728bdf9e870c9f5ca67564_wh=1500_832.webp"
        alt=""
      />
      <div class="recipe-container" v-if="loaded">
        <div class="recipe-title">
          <div class="title">全部食谱</div>
          <div class="t-info"
            ><span class="iconfont icon-V" @click="bindClickTips"></span
            ><span class="use-info"
              >已使用{{ usedNum }}期，剩余<span class="t-num"
                >{{ surplusNum }}期</span
              ></span
            ></div
          >
        </div>
        <div class="recipe-list">
          <div
            class="recipe-item"
            v-for="(item, index) in recipeData"
            :key="index"
          >
            <div class="item-left">
              <div class="item-l-top"
                ><span class="item-title">定制食谱第{{ item.index }}期</span>
                <span class="item-status" v-if="item.status == 1">未生成</span>
                <span class="item-status item-used" v-if="item.use_state == 1"
                  >使用中</span
                ></div
              >
              <div class="item-time" v-if="item.status == 3"
                >生成时间：{{ item.finish_time }}</div
              >
            </div>
            <div
              class="item-btn"
              :class="{
                'item-btn-active': item.status == 3,
                'item-btn-disabled': item.disabled
              }"
              @click="bindClick(item)"
              >{{ item.btnText }}</div
            >
          </div>
        </div>
      </div>
      <AppLoading class="app-loading" v-else />
    </div>
  </div>
</template>

<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  name: 'app-camp-customized-recipes',
  components: { AppNavbar, AppLoading },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(255,255,255,0)',
        color: 'rgba(0,0,0,0.8)'
      },
      loaded: false,
      usedNum: 0, //已使用次数
      surplusNum: 0, //剩余次数
      recipeData: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    bindClickTips() {
      this.$toast({
        message: '每月1号下发4期食谱问卷',
        duration: 4000
      })
    },
    bindClick(item) {
      let id = item.id
      let cnaType = item.cnaType
      if (cnaType == 1) {
        switch (item.plan_flag) {
          case -1:
            break
          case 3:
            if (item.success) {
              this.$router.push('/recipe-cna-result?rid=' + id)
            } else {
              this.$router.push('/recipe-cna-submit?rid=' + id + '&sfrom=weVip')
            }
            break
          default:
            this.$router.push('/recipe-cna-start?rid=' + id)
        }
      } else {
        switch (item.cna_state) {
          case 1:
            this.$router.push(
              '/cna-question-v2/start?queId=9&id=' + id + '&from=recipe'
            )
            break
          case 2:
            this.$router.push(
              '/cna-question-v2/start?queId=9&id=' + id + '&from=recipe'
            )
            break
          case 3:
            this.$router.push(
              '/cna-question-v2/result?id=' + id + '&from=recipe'
            )
            break
          default:
            this.$toast('方案已失效')
        }
      }
    },
    async getList() {
      let res = await this.$http
        .postApp('api/v1/WeEquity/getCnaList', {})
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.usedNum = res.data.num
          this.surplusNum = (res.data.issue_total || 0) - res.data.num
          this.recipeData = this.dealDietPlan(
            res.data.poster_list || [],
            res.data.cna_type
          )
          this.getUserRecipe()
        } else {
          this.$toast(res.msg)
        }
      }
      this.loaded = true
    },
    async getUserRecipe() {
      let res = await this.$http
        .getBaseApp('api/v1/DiverseRecipesSquare/getUserRecipe')
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          let data = res.data
          if (data.recipes_type == 1 && data.use_state == 1) {
            this.recipeData.map((item) => {
              if (item.id == data.ref_id) {
                item.use_state = 1
              }
            })
          }
        }
      }
    },
    //处理获得的cna问卷列表数据
    dealDietPlan(data, cnaType) {
      data.map((item, index) => {
        item.use_state = 0
        item.index = index + 1
        item.cnaType = cnaType
        let times = item.que_time && item.que_time.replace(/-/g, '/')
        if (
          times &&
          item.que_time &&
          this.bjTimeToLocal(times).getTime() <= new Date().getTime()
        ) {
          item.success = true
        } else {
          item.success = false
        }
        return item
      })
      data.map((item) => {
        if ((item.success && item.plan_flag == 3) || item.cna_state == 3) {
          item.status = 3
          item.btnText = '去查看'
        } else if (!item.success && item.plan_flag == 3) {
          item.status = 2
          item.btnText = '已提交'
        } else if (item.plan_flag == -1) {
          item.status = 0
          item.btnText = '待使用'
          item.disabled = true
        } else if (item.cna_state == 0) {
          item.status = 4
          item.btnText = '已过期'
          item.disabled = true
        } else {
          item.status = 1
          item.btnText = '去生成'
        }
      })
      data.sort((a, b) => {
        if (b.status == 3 && a.status == 3) {
          //都是已完成时对比更新时间  更新时间较晚的排在前面
          return (
            new Date(b.finish_time.replace(/-/g, '/')) -
            new Date(a.finish_time.replace(/-/g, '/'))
          )
        }
        return a.status - b.status
      })
      return data
    },
    //指定的北京时间信息转成世界各地时间
    bjTimeToLocal(bj_str) {
      let local = new Date(bj_str)
      let bj_zone = 8
      var d = new Date()
      var tmpHours = local.getHours()
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60
      if (time_zone > bj_zone) {
        local.setHours(tmpHours + Math.abs(time_zone - bj_zone))
      } else {
        local.setHours(tmpHours - Math.abs(bj_zone - time_zone))
      }
      return local
    },
    //根据年卡用户cna问卷应获得的问卷数量初始化列表 如果用户已经存在的cna问卷数量不够则添加未使用的
    computeList(list, count) {
      if (list.length < count) {
        let addCount = count - list.length
        for (let i = 0; i < addCount; i++) {
          list.push({
            plan_flag: -1
          })
        }
      }
      return list
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.custom-recipe {
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .bg {
    width: 100%;
    height: 208px;
    object-fit: cover;
  }
  .recipe-container {
    padding: 16px;
    padding-bottom: 100px;
    .recipe-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 10px;
      .title {
        font-weight: bold;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.4);
        line-height: 22px;
      }
      .t-info {
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        .iconfont {
          width: 13px;
          height: 13px;
          box-sizing: border-box;
          border-radius: 7px;
          text-align: center;
          line-height: 12px;
          font-size: 10px;
          color: #999;
          border: 1px solid #999;
          margin-right: 6px;
        }
        .use-info {
          height: 17px;
          line-height: 17px;
        }
      }
      .t-num {
        color: rgba(0, 0, 0, 0.8);
      }
    }
    .recipe-list {
      .recipe-item {
        margin-bottom: 10px;
        background: linear-gradient(180deg, #f5fffa 0%, #ffffff 100%);
        border-radius: 6px;
        display: flex;
        align-items: center;
        padding: 18px 22px 18px 18px;
        height: 81px;
        box-sizing: border-box;
        .item-left {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          margin-right: 6px;
          .item-l-top {
            display: flex;
            align-items: center;
            .item-title {
              font-weight: bold;
              font-size: 16px;
              line-height: 22px;
            }
            .item-status {
              height: 16px;
              padding: 0px 3px;
              background: #ffa112;
              border-radius: 2px;
              margin-left: 6px;
              font-weight: bold;
              line-height: 16px;
              font-size: 10px;
              color: #ffffff;
            }
            .item-used {
              background: #24c789;
            }
          }
          .item-time {
            margin-top: 6px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 17px;
          }
        }
        .item-btn {
          box-sizing: border-box;
          width: 72px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          border-radius: 15px;
          background: #24c789;
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 12px;
          color: #ffffff;
        }
        .item-btn-disabled {
          background-color: #999;
        }
        .item-btn-active {
          border: 1px solid #24c789;
          background: none;
          color: #24c789;
        }
      }
    }
  }
}
</style>
